import { inject, Pipe } from '@angular/core';
import { Store } from '@ngxs/store';
import { LabelSlot } from '../@store/types';
import { JupiterState } from '../@store/state';

@Pipe({ name: 'jupiterLabelSlot', standalone: true })
export class LabelSlotPipe {
  store = inject(Store);

  transform(value: LabelSlot, tick?: any, overrideLabel?: string): string {
    if (overrideLabel) {
      return overrideLabel;
    }

    return this.store.selectSnapshot(JupiterState.getLabelSlot(value));
  }
}
